function MenuBar(){
    return(
        <div className="row menubar">
            <div className="col-md-3 col-sm-6 col-6 mb-md-0 mb-sm-1 mb-1 text-center align-self-center">
            <a href="https://play.google.com/store/apps/details?id=com.inria.biodimetre" target="_blank" rel="noopener noreferrer">Application Android</a>
 
            </div>
            <div className="col-md-3 col-sm-6 col-6 mb-md-0 mb-sm-1 mb-1 text-center align-self-center">
            <a href="https://apps.apple.com/fr/app/biodim%C3%A8tre/id1570789679" target="_blank" rel="noopener noreferrer">Application iOS</a>
            </div>
            <div className="col-md-3 col-sm-6 col-6 mb-md-0 mb-sm-1 mb-1 text-center align-self-center">
            <a href="/about">À propos</a>
            </div>
            <div className="col-md-3 col-sm-6 col-6 mb-md-0 mb-sm-1 mb-1 text-center align-self-center">
            <a href="/privacy">Confidentialité</a>
            </div>
        </div>
    )
}

export default MenuBar;